module.exports = __webpack_public_path__ + "img/smart-ai-assistant.70a6435b.png";